import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  backToLoginEmphasisSx,
  backToLoginLinkSx,
  surveyFirstBackToLoginLinkSx,
} from '../styles/instrumentOnboardingStyles'
import { signupShareBackToLoginEmphasisSx, useSignupShareTheme } from '../styles/signupShareTheme'

export function BackToLoginLink() {
  const signupTheme = useSignupShareTheme()
  return (
    <Typography
      component="p"
      sx={[backToLoginLinkSx, signupTheme ? surveyFirstBackToLoginLinkSx : null]}
      data-testid="instrument-onboarding-back-login"
    >
      <RouterLink to="/login" data-testid="instrument-onboarding-login-link">
        {signupTheme ? (
          <Box component="span" sx={signupShareBackToLoginEmphasisSx}>
            log in
          </Box>
        ) : (
          <Box component="span" sx={backToLoginEmphasisSx}>
            log in
          </Box>
        )}
      </RouterLink>
    </Typography>
  )
}
